module.exports = __webpack_public_path__ + "img/source-support.20d49106.png";